# This gets automatically populated bij gulp

exports.date = 1490276591
exports.branch = "master"
exports.hash = "f989af9"
exports.build = 2656
exports.version = "#{exports.branch}/#{exports.hash}"



// WEBPACK FOOTER //
// ./build/Version.coffee